module.exports = __webpack_public_path__ + "img/icon-qianc.4a51663c.png";